import { ShareLinkOtherSettings, TreeToolbar } from "slot-definitions"
import { Feature, isEnabled } from "lib/@components/feature"

import { FEATURE_FLAG_PLANNING } from "routes/plan/feature-flags.mjs"
import { AddConformityButton } from "routes/conformity/components/add-conformity/add-conformity-button"
import { ConformityDocumentsShareLinkSetting } from "routes/conformity/components/add-conformity/conformity-documents-share-link-setting"

TreeToolbar.plug(
    <Feature feature={FEATURE_FLAG_PLANNING} if={(c) => c.inFacility && !c.schedule}>
        <AddConformityButton />
    </Feature>
)

ShareLinkOtherSettings.plug(<ConformityDocumentsShareLinkSetting if={() => isEnabled(FEATURE_FLAG_PLANNING)} />)
